import get from 'lodash/get';

const copyToClipboard = (text) => {
  const clipboard = get(navigator, 'clipboard', null);
  if (clipboard) clipboard.writeText(text);
};

export default copyToClipboard;
